module.exports = __webpack_public_path__ + "i18n/pl.d8da820d2184e217734c9edf6f665878.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/pl.json
// module id = 1007
// module chunks = 60